// extracted by mini-css-extract-plugin
module.exports = {"ReservedMessageWrapper":"ReservedMessage-module__ReservedMessageWrapper","btn":"ReservedMessage-module__btn"};